import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID7hggqo3abtya as VOID,
  createThis2j2avj17cvnv2 as createThis,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  protoOf180f3jzyo7rfj as protoOf,
  Comparable198qfk8pnblz0 as Comparable,
  KtList3hktaavzmj137 as KtList,
  toSet2orjxp16sotqu as toSet,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  isNaNymqb93xtq8w8 as isNaN_0,
  Unit_instanceat14thlj150z as Unit_instance,
  Enum3alwj03lh1n41 as Enum,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  contentEquals379bkuxwxaiqz as contentEquals,
  contentHashCode2dpr73siofp13 as contentHashCode,
  StringBuildermazzzhj6kkai as StringBuilder,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  numberToDouble210hrknaofnhf as numberToDouble,
  coerceIn10f36k81le1mm as coerceIn,
  minOfmf6w75l7u1a7 as minOf,
  maxOf1m19db8qhkqy5 as maxOf,
} from './kotlin-kotlin-stdlib.mjs';
import {
  _Ratio___init__impl__9mwvn2xyj9fjgana63 as _Ratio___init__impl__9mwvn2,
  umod1d8wj61c81r0q as umod,
  isAlmostEquals2e7wogp48cvmj as isAlmostEquals,
  Ratio__toDouble_impl_o7epze2ppsc3gplivz8 as Ratio__toDouble_impl_o7epze,
  toRatio1hooqit5gulhr as toRatio,
  Ratio__times_impl_ucdh7y2x1w5kf040xma as Ratio__times_impl_ucdh7y,
  Ratio__compareTo_impl_z2iencsp0le8uhwq33 as Ratio__compareTo_impl_z2ienc,
  roundDecimalPlaces1x32iuyd1l8m5 as roundDecimalPlaces,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  isAlmostEquals$default2ib7nwup21mfy as isAlmostEquals$default,
  IsAlmostEquals2vs54x7i426j2 as IsAlmostEquals,
  interpolate2g7wzskc23f1q as interpolate,
  interpolate35pbs3ac913y4 as interpolate_0,
  get_niceStr1tlwtz2l2j4my as get_niceStr_0,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    this.d25_1 = Anchor2D.o25(0.0, 0.0);
    this.e25_1 = Anchor2D.o25(0.5, 0.0);
    this.f25_1 = Anchor2D.o25(1.0, 0.0);
    this.g25_1 = Anchor2D.o25(0.0, 0.5);
    this.h25_1 = Anchor2D.o25(0.5, 0.5);
    this.i25_1 = Anchor2D.o25(1.0, 0.5);
    this.j25_1 = Anchor2D.o25(0.0, 1.0);
    this.k25_1 = Anchor2D.o25(0.5, 1.0);
    this.l25_1 = Anchor2D.o25(1.0, 1.0);
  }
  p25() {
    return this.h25_1;
  }
}
class Anchor2D {
  static q25(sx, sy) {
    Companion_getInstance();
    var $this = createThis(this);
    $this.m25_1 = sx;
    $this.n25_1 = sy;
    return $this;
  }
  static o25(sx, sy) {
    Companion_getInstance();
    return this.q25(sx, sy);
  }
  toString() {
    return 'Anchor2D(sx=' + this.m25_1 + ', sy=' + this.n25_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.m25_1);
    result = imul(result, 31) + getNumberHashCode(this.n25_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Anchor2D))
      return false;
    var tmp0_other_with_cast = other instanceof Anchor2D ? other : THROW_CCE();
    if (!equals(this.m25_1, tmp0_other_with_cast.m25_1))
      return false;
    if (!equals(this.n25_1, tmp0_other_with_cast.n25_1))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio = toRatio(1.0E-5);
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio, 6.283185307179586);
    tmp.s25_1 = _Angle___init__impl__g23q1m(tmp$ret$0);
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_0 = toRatio(0.0);
    var tmp$ret$2 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    tmp_0.t25_1 = _Angle___init__impl__g23q1m(tmp$ret$2);
    var tmp_1 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_1 = toRatio(0.25);
    var tmp$ret$4 = Ratio__times_impl_ucdh7y(ratio_1, 6.283185307179586);
    tmp_1.u25_1 = _Angle___init__impl__g23q1m(tmp$ret$4);
    var tmp_2 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_2 = toRatio(0.5);
    var tmp$ret$6 = Ratio__times_impl_ucdh7y(ratio_2, 6.283185307179586);
    tmp_2.v25_1 = _Angle___init__impl__g23q1m(tmp$ret$6);
    var tmp_3 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_3 = toRatio(0.75);
    var tmp$ret$8 = Ratio__times_impl_ucdh7y(ratio_3, 6.283185307179586);
    tmp_3.w25_1 = _Angle___init__impl__g23q1m(tmp$ret$8);
    var tmp_4 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_4 = toRatio(1.0);
    var tmp$ret$10 = Ratio__times_impl_ucdh7y(ratio_4, 6.283185307179586);
    tmp_4.x25_1 = _Angle___init__impl__g23q1m(tmp$ret$10);
  }
}
class Angle {
  constructor(radians) {
    Companion_getInstance_0();
    this.r25_1 = radians;
  }
  y25(other, epsilon) {
    return Angle__isAlmostEquals_impl_201sgt(this.r25_1, other, epsilon);
  }
  c1i(other, epsilon) {
    return Angle__isAlmostEquals_impl_201sgt_0(this, other, epsilon);
  }
  z25(other) {
    return Angle__compareTo_impl_a0hfds(this.r25_1, other);
  }
  d(other) {
    return Angle__compareTo_impl_a0hfds_0(this, other);
  }
  toString() {
    return Angle__toString_impl_786qky(this.r25_1);
  }
  hashCode() {
    return Angle__hashCode_impl_szcndt(this.r25_1);
  }
  equals(other) {
    return Angle__equals_impl_zcf5mt(this.r25_1, other);
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_1 = this;
    this.x26_1 = _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_11().b27());
  }
  c27() {
    return this.x26_1;
  }
  d27(p1, p2, p3, p4) {
    return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_11().g27(Companion_getInstance_17().e27(p1, p2, p3, p4), Companion_getInstance_17().f27(p1, p2, p3, p4)));
  }
}
class BoundsBuilder {
  constructor(bounds) {
    Companion_getInstance_1();
    this.p27_1 = bounds;
  }
  toString() {
    return BoundsBuilder__toString_impl_fmvxh7(this.p27_1);
  }
  hashCode() {
    return BoundsBuilder__hashCode_impl_649zbo(this.p27_1);
  }
  equals(other) {
    return BoundsBuilder__equals_impl_jngfjs(this.p27_1, other);
  }
}
class Companion_2 {}
class Circle {
  constructor(center, radius) {
    this.q27_1 = center;
    this.r27_1 = radius;
  }
  s27() {
    return this.r27_1 * this.r27_1;
  }
  t27(p) {
    return Companion_getInstance_17().u27(p, this.q27_1);
  }
  v27(p) {
    return this.t27(p) - this.s27();
  }
  w27(p) {
    return this.t27(p) + this.s27();
  }
  toString() {
    return 'Circle(center=' + this.q27_1.toString() + ', radius=' + this.r27_1 + ')';
  }
  hashCode() {
    var result = this.q27_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.r27_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Circle))
      return false;
    var tmp0_other_with_cast = other instanceof Circle ? other : THROW_CCE();
    if (!this.q27_1.equals(tmp0_other_with_cast.q27_1))
      return false;
    if (!equals(this.r27_1, tmp0_other_with_cast.r27_1))
      return false;
    return true;
  }
}
class IPointList$Sublist$listIterator$1 {
  constructor($index, this$0) {
    this.y27_1 = $index;
    this.z27_1 = this$0;
    this.x27_1 = $index;
  }
  b1() {
    return this.x27_1 >= this.z27_1.d28_1;
  }
  c1() {
    var _unary__edvuaz = this.x27_1;
    this.x27_1 = _unary__edvuaz + 1 | 0;
    return this.z27_1.f1(_unary__edvuaz);
  }
}
class Sublist {
  constructor(list, fromIndex, toIndex) {
    this.a28_1 = list;
    this.b28_1 = fromIndex;
    this.c28_1 = toIndex;
    this.d28_1 = this.c28_1 - this.b28_1 | 0;
  }
  d1() {
    return this.d28_1;
  }
  f1(index) {
    return this.a28_1.f1(index + this.b28_1 | 0);
  }
  g1() {
    return this.d28_1 === 0;
  }
  a1() {
    return this.u2();
  }
  u2() {
    return this.v2(0);
  }
  v2(index) {
    return new IPointList$Sublist$listIterator$1(index, this);
  }
  w2(fromIndex, toIndex) {
    return new Sublist(this.a28_1, this.b28_1 + fromIndex | 0, this.b28_1 + toIndex | 0);
  }
  e28(element) {
    return Companion_instance_3.f28(this.a28_1, element, this.b28_1, this.c28_1, -this.b28_1 | 0);
  }
  g28(elements) {
    return Companion_instance_3.h28(this, elements);
  }
  t2(elements) {
    return this.g28(elements);
  }
  i28(element) {
    return this.e28(element) >= 0;
  }
  k1(element) {
    if (!(element instanceof Vector2D))
      return false;
    return this.i28(element instanceof Vector2D ? element : THROW_CCE());
  }
}
class Companion_3 {
  h28(_this__u8e3s4, elements) {
    var s = toSet(elements);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(_this__u8e3s4, Collection)) {
        tmp = _this__u8e3s4.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = _this__u8e3s4.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.math.geom.Companion.containsAllSet.<anonymous>' call
        if (!s.k1(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  f28(list, element, fromIndex, toIndex, offset) {
    var inductionVariable = fromIndex;
    if (inductionVariable < toIndex)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (list.j28(n) === element.c26_1 && list.k28(n) === element.d26_1)
          return n + offset | 0;
      }
       while (inductionVariable < toIndex);
    return -1;
  }
}
class IDoubleVectorList {}
function isNotEmpty() {
  return !(this.d1() === 0);
}
function isAlmostEquals_0(other, epsilon) {
  if (!(this.d1() === other.d1()))
    return false;
  if (!(this.p28() === other.p28()))
    return false;
  var inductionVariable = 0;
  var last = this.p28();
  if (inductionVariable < last)
    do {
      var dim = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = this.d1();
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!isAlmostEquals(this.n28(n, dim), other.n28(n, dim), epsilon))
            return false;
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  return true;
}
class IPointList {}
function get(index) {
  return Vector2D.l28(this.j28(index), this.k28(index));
}
function containsAll(elements) {
  return Companion_instance_3.h28(this, elements);
}
function iterator() {
  return this.u2();
}
function listIterator() {
  return this.v2(0);
}
function listIterator_0(index) {
  return (new Sublist(this, 0, this.d1())).v2(index);
}
function subList(fromIndex, toIndex) {
  return new Sublist(this, fromIndex, toIndex);
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
    this.q28_1 = Line2D.u28(Companion_getInstance_17().e26_1, Companion_getInstance_17().e26_1);
    this.r28_1 = Line2D.u28(Companion_getInstance_17().f26_1, Companion_getInstance_17().f26_1);
  }
}
class Line2D {
  static u28(a, b) {
    Companion_getInstance_4();
    var $this = createThis(this);
    $this.s28_1 = a;
    $this.t28_1 = b;
    return $this;
  }
  static v28() {
    Companion_getInstance_4();
    return this.u28(Vector2D.w28(), Vector2D.w28());
  }
  static x28(x0, y0, x1, y1) {
    Companion_getInstance_4();
    return this.u28(Vector2D.y28(x0, y0), Vector2D.y28(x1, y1));
  }
  z28() {
    return this.s28_1.c26_1;
  }
  a29() {
    return this.s28_1.d26_1;
  }
  b29() {
    return this.t28_1.c26_1;
  }
  c29() {
    return this.t28_1.d26_1;
  }
  toString() {
    return 'Line(' + this.s28_1.toString() + ', ' + this.t28_1.toString() + ')';
  }
  hashCode() {
    var result = this.s28_1.hashCode();
    result = imul(result, 31) + this.t28_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Line2D))
      return false;
    var tmp0_other_with_cast = other instanceof Line2D ? other : THROW_CCE();
    if (!this.s28_1.equals(tmp0_other_with_cast.s28_1))
      return false;
    if (!this.t28_1.equals(tmp0_other_with_cast.t28_1))
      return false;
    return true;
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_5 = this;
    this.d29_1 = MarginInt.i29(0, 0, 0, 0);
  }
}
class MarginInt {
  static i29(top, right, bottom, left) {
    Companion_getInstance_5();
    var $this = createThis(this);
    $this.e29_1 = top;
    $this.f29_1 = right;
    $this.g29_1 = bottom;
    $this.h29_1 = left;
    return $this;
  }
  static j29(margin) {
    Companion_getInstance_5();
    return this.i29(margin, margin, margin, margin);
  }
  k29() {
    return !(this.e29_1 === 0) || !(this.h29_1 === 0) || !(this.f29_1 === 0) || !(this.g29_1 === 0);
  }
  l29() {
    return this.h29_1 + this.f29_1 | 0;
  }
  m29() {
    return this.e29_1 + this.g29_1 | 0;
  }
  toString() {
    return 'MarginInt(top=' + this.e29_1 + ', right=' + this.f29_1 + ', bottom=' + this.g29_1 + ', left=' + this.h29_1 + ')';
  }
  hashCode() {
    var result = this.e29_1;
    result = imul(result, 31) + this.f29_1 | 0;
    result = imul(result, 31) + this.g29_1 | 0;
    result = imul(result, 31) + this.h29_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MarginInt))
      return false;
    var tmp0_other_with_cast = other instanceof MarginInt ? other : THROW_CCE();
    if (!(this.e29_1 === tmp0_other_with_cast.e29_1))
      return false;
    if (!(this.f29_1 === tmp0_other_with_cast.f29_1))
      return false;
    if (!(this.g29_1 === tmp0_other_with_cast.g29_1))
      return false;
    if (!(this.h29_1 === tmp0_other_with_cast.h29_1))
      return false;
    return true;
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_6 = this;
    this.n29_1 = new Matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0);
    this.o29_1 = new Matrix(NaN, NaN, NaN, NaN, NaN, NaN);
    this.p29_1 = this.o29_1;
  }
  q29() {
    return this.n29_1;
  }
  r29(a, b, epsilon) {
    return isAlmostEquals(a.w29_1, b.w29_1, epsilon) && isAlmostEquals(a.x29_1, b.x29_1, epsilon) && isAlmostEquals(a.s29_1, b.s29_1, epsilon) && isAlmostEquals(a.t29_1, b.t29_1, epsilon) && isAlmostEquals(a.u29_1, b.u29_1, epsilon) && isAlmostEquals(a.v29_1, b.v29_1, epsilon);
  }
  y29(l, r) {
    if (l.r26())
      return r;
    if (r.r26())
      return l;
    return new Matrix(l.s29_1 * r.s29_1 + l.t29_1 * r.u29_1, l.s29_1 * r.t29_1 + l.t29_1 * r.v29_1, l.u29_1 * r.s29_1 + l.v29_1 * r.u29_1, l.u29_1 * r.t29_1 + l.v29_1 * r.v29_1, l.w29_1 * r.s29_1 + l.x29_1 * r.u29_1 + r.w29_1, l.w29_1 * r.t29_1 + l.x29_1 * r.v29_1 + r.x29_1);
  }
  z29(angle) {
    return Companion_getInstance_6().n29_1.a2a(angle);
  }
  b2a(x, y, rotation, scaleX, scaleY, skewX, skewY, pivotX, pivotY) {
    // Inline function 'korlibs.math.geom.cos' call
    var angle = Angle__plus_impl_26v37k(rotation, skewY);
    var up = Companion_getInstance_17().i26_1;
    var a = Angle__cosine_impl_bgvzun(angle, up) * scaleX + 0.0;
    // Inline function 'korlibs.math.geom.sin' call
    var angle_0 = Angle__plus_impl_26v37k(rotation, skewY);
    var up_0 = Companion_getInstance_17().i26_1;
    var b = Angle__sine_impl_3l11xv(angle_0, up_0) * scaleX + 0.0;
    // Inline function 'korlibs.math.geom.sin' call
    var angle_1 = Angle__minus_impl_xeau7k(rotation, skewX);
    var up_1 = Companion_getInstance_17().i26_1;
    var c = -Angle__sine_impl_3l11xv(angle_1, up_1) * scaleY + 0.0;
    // Inline function 'korlibs.math.geom.cos' call
    var angle_2 = Angle__minus_impl_xeau7k(rotation, skewX);
    var up_2 = Companion_getInstance_17().i26_1;
    var d = Angle__cosine_impl_bgvzun(angle_2, up_2) * scaleY + 0.0;
    var tx;
    var ty;
    if (pivotX === 0.0 && pivotY === 0.0) {
      tx = x;
      ty = y;
    } else {
      tx = x - (pivotX * a + pivotY * c);
      ty = y - (pivotX * b + pivotY * d);
    }
    return new Matrix(a, b, c, d, tx, ty);
  }
  c2a(a, b, c, d, tx, ty, p) {
    return Vector2D.l28(a * p.c26_1 + c * p.d26_1 + tx, d * p.d26_1 + b * p.c26_1 + ty);
  }
  d2a(l, r, ratio) {
    return new Matrix(interpolate_0(ratio, l.s29_1, r.s29_1), interpolate_0(ratio, l.t29_1, r.t29_1), interpolate_0(ratio, l.u29_1, r.u29_1), interpolate_0(ratio, l.v29_1, r.v29_1), interpolate_0(ratio, l.w29_1, r.w29_1), interpolate_0(ratio, l.x29_1, r.x29_1));
  }
}
class Matrix {
  constructor(a, b, c, d, tx, ty) {
    Companion_getInstance_6();
    tx = tx === VOID ? 0.0 : tx;
    ty = ty === VOID ? 0.0 : ty;
    this.s29_1 = a;
    this.t29_1 = b;
    this.u29_1 = c;
    this.v29_1 = d;
    this.w29_1 = tx;
    this.x29_1 = ty;
  }
  e2a(other) {
    return Companion_getInstance_6().y29(this, other);
  }
  r26() {
    return isNaN_0(this.s29_1);
  }
  s26() {
    return !this.r26();
  }
  f2a() {
    return this.s29_1 === 1.0 && this.t29_1 === 0.0 && this.u29_1 === 0.0 && this.v29_1 === 1.0 && this.w29_1 === 0.0 && this.x29_1 === 0.0;
  }
  g2a() {
    var hasRotation = !(this.t29_1 === 0.0) || !(this.u29_1 === 0.0);
    var hasScale = !(this.s29_1 === 1.0) || !(this.v29_1 === 1.0);
    var hasTranslation = !(this.w29_1 === 0.0) || !(this.x29_1 === 0.0);
    return hasRotation ? MatrixType_COMPLEX_getInstance() : hasScale && hasTranslation ? MatrixType_SCALE_TRANSLATE_getInstance() : hasScale ? MatrixType_SCALE_getInstance() : hasTranslation ? MatrixType_TRANSLATE_getInstance() : MatrixType_IDENTITY_getInstance();
  }
  h2a(p) {
    return this.i2a(p.c26_1, p.d26_1);
  }
  j2a(x, y) {
    return this.i2a(x, y);
  }
  k2a(x, y) {
    return this.l2a(x, y);
  }
  i2a(x, y) {
    return this.s29_1 * x + this.u29_1 * y + this.w29_1;
  }
  l2a(x, y) {
    return this.v29_1 * y + this.t29_1 * x + this.x29_1;
  }
  m2a(x, y) {
    return this.i2a(x, y);
  }
  n2a(x, y) {
    return this.l2a(x, y);
  }
  a2a(angle) {
    // Inline function 'korlibs.math.geom.cos' call
    var up = Companion_getInstance_17().i26_1;
    var cos = Angle__cosine_impl_bgvzun(angle, up);
    // Inline function 'korlibs.math.geom.sin' call
    var up_0 = Companion_getInstance_17().i26_1;
    var sin = Angle__sine_impl_3l11xv(angle, up_0);
    var a1 = this.s29_1 * cos - this.t29_1 * sin;
    var b = this.s29_1 * sin + this.t29_1 * cos;
    var a = a1;
    var c1 = this.u29_1 * cos - this.v29_1 * sin;
    var d = this.u29_1 * sin + this.v29_1 * cos;
    var c = c1;
    var tx1 = this.w29_1 * cos - this.x29_1 * sin;
    var ty = this.w29_1 * sin + this.x29_1 * cos;
    var tx = tx1;
    return new Matrix(a, b, c, d, tx, ty);
  }
  o2a(scaleX, scaleY) {
    return this.p2a(scaleX, scaleY);
  }
  p2a(scaleX, scaleY) {
    return new Matrix(this.s29_1 * scaleX, this.t29_1 * scaleX, this.u29_1 * scaleY, this.v29_1 * scaleY, this.w29_1 * scaleX, this.x29_1 * scaleY);
  }
  q2a(scaleX, scaleY, $super) {
    scaleY = scaleY === VOID ? scaleX : scaleY;
    return $super === VOID ? this.p2a(scaleX, scaleY) : $super.p2a.call(this, scaleX, scaleY);
  }
  r2a(scaleX, scaleY) {
    return new Matrix(this.s29_1 * scaleX, this.t29_1 * scaleX, this.u29_1 * scaleY, this.v29_1 * scaleY, this.w29_1, this.x29_1);
  }
  s2a(scaleX, scaleY, $super) {
    scaleY = scaleY === VOID ? scaleX : scaleY;
    return $super === VOID ? this.r2a(scaleX, scaleY) : $super.r2a.call(this, scaleX, scaleY);
  }
  t2a(delta) {
    return new Matrix(this.s29_1, this.t29_1, this.u29_1, this.v29_1, this.w29_1 + delta.c26_1, this.x29_1 + delta.d26_1);
  }
  u2a(x, y) {
    return this.t2a(Vector2D.y28(x, y));
  }
  v2a(x, y) {
    return this.t2a(Vector2D.l28(x, y));
  }
  w2a(delta) {
    return new Matrix(this.s29_1, this.t29_1, this.u29_1, this.v29_1, this.w29_1 + (this.s29_1 * delta.c26_1 + this.u29_1 * delta.d26_1), this.x29_1 + (this.t29_1 * delta.c26_1 + this.v29_1 * delta.d26_1));
  }
  x2a(deltaX, deltaY) {
    return this.w2a(Vector2D.y2a(deltaX, deltaY));
  }
  z2a(deltaX, deltaY) {
    return this.w2a(Vector2D.l28(deltaX, deltaY));
  }
  a2b(angle) {
    return Companion_getInstance_6().z29(angle).e2a(this);
  }
  b2b(m) {
    return m.e2a(this);
  }
  c2b() {
    if (this.r26())
      return Companion_getInstance_6().n29_1;
    var m = this;
    var norm = m.s29_1 * m.v29_1 - m.t29_1 * m.u29_1;
    var tmp;
    if (norm === 0.0) {
      tmp = new Matrix(0.0, 0.0, 0.0, 0.0, -m.w29_1, -m.x29_1);
    } else {
      var inorm = 1.0 / norm;
      var d = m.s29_1 * inorm;
      var a = m.v29_1 * inorm;
      var b = m.t29_1 * -inorm;
      var c = m.u29_1 * -inorm;
      tmp = new Matrix(a, b, c, d, -a * m.w29_1 - c * m.x29_1, -b * m.w29_1 - d * m.x29_1);
    }
    return tmp;
  }
  d2b() {
    return this.e2b();
  }
  e2b() {
    return Companion_getInstance_7().g2b(this);
  }
  toString() {
    return 'Matrix(' + get_niceStr(this.s29_1) + ', ' + get_niceStr(this.t29_1) + ', ' + get_niceStr(this.u29_1) + ', ' + get_niceStr(this.v29_1) + ', ' + get_niceStr(this.w29_1) + ', ' + get_niceStr(this.x29_1) + ')';
  }
  h2b(other, epsilon) {
    return Companion_getInstance_6().r29(this, other, epsilon);
  }
  c1i(other, epsilon) {
    return this.h2b(other instanceof Matrix ? other : THROW_CCE(), epsilon);
  }
  i2b(other) {
    return this.e2a(other);
  }
  hashCode() {
    var result = getNumberHashCode(this.s29_1);
    result = imul(result, 31) + getNumberHashCode(this.t29_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u29_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v29_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w29_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.x29_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Matrix))
      return false;
    var tmp0_other_with_cast = other instanceof Matrix ? other : THROW_CCE();
    if (!equals(this.s29_1, tmp0_other_with_cast.s29_1))
      return false;
    if (!equals(this.t29_1, tmp0_other_with_cast.t29_1))
      return false;
    if (!equals(this.u29_1, tmp0_other_with_cast.u29_1))
      return false;
    if (!equals(this.v29_1, tmp0_other_with_cast.v29_1))
      return false;
    if (!equals(this.w29_1, tmp0_other_with_cast.w29_1))
      return false;
    if (!equals(this.x29_1, tmp0_other_with_cast.x29_1))
      return false;
    return true;
  }
}
class MatrixType extends Enum {
  constructor(name, ordinal, id, hasRotation, hasScale, hasTranslation) {
    super(name, ordinal);
    this.l2b_1 = id;
    this.m2b_1 = hasRotation;
    this.n2b_1 = hasScale;
    this.o2b_1 = hasTranslation;
  }
}
class Companion_7 {
  constructor() {
    Companion_instance_7 = this;
    this.f2b_1 = MatrixTransform.w2b(0.0, 0.0, 1.0, 1.0, Companion_getInstance_0().t25_1, Companion_getInstance_0().t25_1, Companion_getInstance_0().t25_1);
  }
  x2b(matrix, pivotX, pivotY) {
    var a = matrix.s29_1;
    var b = matrix.t29_1;
    var c = matrix.u29_1;
    var d = matrix.v29_1;
    // Inline function 'kotlin.math.atan2' call
    var y = -c;
    var skewX = -Math.atan2(y, d);
    // Inline function 'kotlin.math.atan2' call
    var skewY = Math.atan2(b, a);
    // Inline function 'kotlin.math.abs' call
    var x = skewX + skewY;
    var delta = Math.abs(x);
    var trotation;
    var tskewX;
    var tskewY;
    var tx;
    var ty;
    var tmp;
    if (delta < 0.001) {
      tmp = true;
    } else {
      // Inline function 'kotlin.math.abs' call
      var x_0 = 3.141592653589793 * 2 - delta;
      tmp = Math.abs(x_0) < 0.001;
    }
    if (tmp) {
      trotation = get_radians_0(skewY);
      tskewX = get_radians_0(0.0);
      tskewY = get_radians_0(0.0);
    } else {
      trotation = get_radians(0);
      tskewX = get_radians_0(skewX);
      tskewY = get_radians_0(skewY);
    }
    // Inline function 'kotlin.math.hypot' call
    var tscaleX = hypot(a, b);
    // Inline function 'kotlin.math.hypot' call
    var tscaleY = hypot(c, d);
    if (pivotX === 0.0 && pivotY === 0.0) {
      tx = matrix.w29_1;
      ty = matrix.x29_1;
    } else {
      tx = matrix.w29_1 + (pivotX * a + pivotY * c);
      ty = matrix.x29_1 + (pivotX * b + pivotY * d);
    }
    return MatrixTransform.w2b(tx, ty, tscaleX, tscaleY, tskewX, tskewY, trotation);
  }
  g2b(matrix, pivotX, pivotY, $super) {
    pivotX = pivotX === VOID ? 0.0 : pivotX;
    pivotY = pivotY === VOID ? 0.0 : pivotY;
    return $super === VOID ? this.x2b(matrix, pivotX, pivotY) : $super.x2b.call(this, matrix, pivotX, pivotY);
  }
  y2b(a, b, epsilon) {
    return isAlmostEquals(a.p2b_1, b.p2b_1, epsilon) && isAlmostEquals(a.q2b_1, b.q2b_1, epsilon) && isAlmostEquals(a.r2b_1, b.r2b_1, epsilon) && isAlmostEquals(a.s2b_1, b.s2b_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.t2b_1, b.t2b_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.u2b_1, b.u2b_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.v2b_1, b.v2b_1, epsilon);
  }
}
class MatrixTransform {
  static w2b(x, y, scaleX, scaleY, skewX, skewY, rotation) {
    Companion_getInstance_7();
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    scaleX = scaleX === VOID ? 1.0 : scaleX;
    scaleY = scaleY === VOID ? 1.0 : scaleY;
    skewX = skewX === VOID ? Companion_getInstance_0().t25_1 : skewX;
    skewY = skewY === VOID ? Companion_getInstance_0().t25_1 : skewY;
    rotation = rotation === VOID ? Companion_getInstance_0().t25_1 : rotation;
    var $this = createThis(this);
    $this.p2b_1 = x;
    $this.q2b_1 = y;
    $this.r2b_1 = scaleX;
    $this.s2b_1 = scaleY;
    $this.t2b_1 = skewX;
    $this.u2b_1 = skewY;
    $this.v2b_1 = rotation;
    return $this;
  }
  toString() {
    return 'MatrixTransform(x=' + get_niceStr(this.p2b_1) + ', y=' + get_niceStr(this.q2b_1) + ', scaleX=' + this.r2b_1 + ', scaleY=' + this.s2b_1 + ', skewX=' + Angle__toString_impl_786qky(this.t2b_1) + ', skewY=' + Angle__toString_impl_786qky(this.u2b_1) + ', rotation=' + Angle__toString_impl_786qky(this.v2b_1) + ')';
  }
  static z2b() {
    Companion_getInstance_7();
    return this.w2b(0.0, 0.0, 1.0, 1.0, Companion_getInstance_0().t25_1, Companion_getInstance_0().t25_1, Companion_getInstance_0().t25_1);
  }
  a2c(other, epsilon) {
    return Companion_getInstance_7().y2b(this, other, epsilon);
  }
  c1i(other, epsilon) {
    return this.a2c(other instanceof MatrixTransform ? other : THROW_CCE(), epsilon);
  }
  b2c() {
    return (this.r2b_1 + this.s2b_1) * 0.5;
  }
  hashCode() {
    var result = getNumberHashCode(this.p2b_1);
    result = imul(result, 31) + getNumberHashCode(this.q2b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r2b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s2b_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.t2b_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.u2b_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.v2b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MatrixTransform))
      return false;
    var tmp0_other_with_cast = other instanceof MatrixTransform ? other : THROW_CCE();
    if (!equals(this.p2b_1, tmp0_other_with_cast.p2b_1))
      return false;
    if (!equals(this.q2b_1, tmp0_other_with_cast.q2b_1))
      return false;
    if (!equals(this.r2b_1, tmp0_other_with_cast.r2b_1))
      return false;
    if (!equals(this.s2b_1, tmp0_other_with_cast.s2b_1))
      return false;
    if (!equals(this.t2b_1, tmp0_other_with_cast.t2b_1))
      return false;
    if (!equals(this.u2b_1, tmp0_other_with_cast.u2b_1))
      return false;
    if (!equals(this.v2b_1, tmp0_other_with_cast.v2b_1))
      return false;
    return true;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_8 = this;
    this.c2c_1 = 0;
    this.d2c_1 = 1;
    this.e2c_1 = 2;
    this.f2c_1 = 3;
    this.g2c_1 = 4;
    this.h2c_1 = 5;
    this.i2c_1 = 6;
    this.j2c_1 = 7;
    this.k2c_1 = 8;
    this.l2c_1 = 9;
    this.m2c_1 = 10;
    this.n2c_1 = 11;
    this.o2c_1 = 12;
    this.p2c_1 = 13;
    this.q2c_1 = 14;
    this.r2c_1 = 15;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp.s2c_1 = new Int32Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]);
    var tmp_0 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_0.t2c_1 = new Int32Array([0, 4, 8, 12, 1, 5, 9, 13, 2, 6, 10, 14, 3, 7, 11, 15]);
    var tmp_1 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_1.u2c_1 = new Int32Array([0, 1, 2, 4, 5, 6, 8, 9, 10]);
    var tmp_2 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_2.v2c_1 = new Int32Array([0, 4, 8, 1, 5, 9, 2, 6, 10]);
    this.w2c_1 = Matrix4.y2c();
  }
  z2c(v00, v01, v02, v03, v10, v11, v12, v13, v20, v21, v22, v23, v30, v31, v32, v33) {
    return Matrix4.a2d(v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33);
  }
  b2d(l, r) {
    return Companion_getInstance_8().z2c(l.c2d() * r.c2d() + l.d2d() * r.e2d() + l.f2d() * r.g2d() + l.h2d() * r.i2d(), l.c2d() * r.d2d() + l.d2d() * r.j2d() + l.f2d() * r.k2d() + l.h2d() * r.l2d(), l.c2d() * r.f2d() + l.d2d() * r.m2d() + l.f2d() * r.n2d() + l.h2d() * r.o2d(), l.c2d() * r.h2d() + l.d2d() * r.p2d() + l.f2d() * r.q2d() + l.h2d() * r.r2d(), l.e2d() * r.c2d() + l.j2d() * r.e2d() + l.m2d() * r.g2d() + l.p2d() * r.i2d(), l.e2d() * r.d2d() + l.j2d() * r.j2d() + l.m2d() * r.k2d() + l.p2d() * r.l2d(), l.e2d() * r.f2d() + l.j2d() * r.m2d() + l.m2d() * r.n2d() + l.p2d() * r.o2d(), l.e2d() * r.h2d() + l.j2d() * r.p2d() + l.m2d() * r.q2d() + l.p2d() * r.r2d(), l.g2d() * r.c2d() + l.k2d() * r.e2d() + l.n2d() * r.g2d() + l.q2d() * r.i2d(), l.g2d() * r.d2d() + l.k2d() * r.j2d() + l.n2d() * r.k2d() + l.q2d() * r.l2d(), l.g2d() * r.f2d() + l.k2d() * r.m2d() + l.n2d() * r.n2d() + l.q2d() * r.o2d(), l.g2d() * r.h2d() + l.k2d() * r.p2d() + l.n2d() * r.q2d() + l.q2d() * r.r2d(), l.i2d() * r.c2d() + l.l2d() * r.e2d() + l.o2d() * r.g2d() + l.r2d() * r.i2d(), l.i2d() * r.d2d() + l.l2d() * r.j2d() + l.o2d() * r.k2d() + l.r2d() * r.l2d(), l.i2d() * r.f2d() + l.l2d() * r.m2d() + l.o2d() * r.n2d() + l.r2d() * r.o2d(), l.i2d() * r.h2d() + l.l2d() * r.p2d() + l.o2d() * r.q2d() + l.r2d() * r.r2d());
  }
  s2d(left, right, bottom, top, near, far) {
    var sx = 2.0 / (right - left);
    var sy = 2.0 / (top - bottom);
    var sz = -2.0 / (far - near);
    var tx = -(right + left) / (right - left);
    var ty = -(top + bottom) / (top - bottom);
    var tz = -(far + near) / (far - near);
    return Companion_getInstance_8().z2c(sx, 0.0, 0.0, tx, 0.0, sy, 0.0, ty, 0.0, 0.0, sz, tz, 0.0, 0.0, 0.0, 1.0);
  }
  t2d(left, right, bottom, top, near, far) {
    return this.s2d(left, right, bottom, top, near, far);
  }
}
class Matrix4 {
  static u2d(data) {
    Companion_getInstance_8();
    var $this = createThis(this);
    $this.x2c_1 = data;
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!($this.x2c_1.length === 16)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.s4(toString(message));
    }
    return $this;
  }
  c2d() {
    return this.x2c_1[0];
  }
  e2d() {
    return this.x2c_1[1];
  }
  g2d() {
    return this.x2c_1[2];
  }
  i2d() {
    return this.x2c_1[3];
  }
  d2d() {
    return this.x2c_1[4];
  }
  j2d() {
    return this.x2c_1[5];
  }
  k2d() {
    return this.x2c_1[6];
  }
  l2d() {
    return this.x2c_1[7];
  }
  f2d() {
    return this.x2c_1[8];
  }
  m2d() {
    return this.x2c_1[9];
  }
  n2d() {
    return this.x2c_1[10];
  }
  o2d() {
    return this.x2c_1[11];
  }
  h2d() {
    return this.x2c_1[12];
  }
  p2d() {
    return this.x2c_1[13];
  }
  q2d() {
    return this.x2c_1[14];
  }
  r2d() {
    return this.x2c_1[15];
  }
  equals(other) {
    var tmp;
    if (other instanceof Matrix4) {
      tmp = contentEquals(this.x2c_1, other.x2c_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode(this.x2c_1);
  }
  v2d(that) {
    return Companion_getInstance_8().b2d(this, that);
  }
  static a2d(v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33) {
    Companion_getInstance_8();
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$0 = new Float32Array([v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33]);
    return this.u2d(tmp$ret$0);
  }
  static y2c() {
    Companion_getInstance_8();
    return this.a2d(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
  }
  n28(row, column) {
    if (!(0 <= column ? column <= 3 : false) || !(0 <= row ? row <= 3 : false)) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid index ' + row + ',' + column;
      throw IllegalStateException.s4(toString(message));
    }
    return this.x2c_1[imul(row, 4) + column | 0];
  }
  w2d(index) {
    if (!(0 <= index ? index <= (this.x2c_1.length - 1 | 0) : false)) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid index ' + index;
      throw IllegalStateException.s4(toString(message));
    }
    return this.x2c_1[index];
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.Matrix4.toString.<anonymous>' call
    this_0.nb('Matrix4(\n');
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var row = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0.nb('  [ ');
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var col = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!(col === 0)) {
              this_0.nb(', ');
            }
            var v = this.n28(row, col);
            // Inline function 'kotlin.math.floor' call
            if (Math.floor(v) === v)
              this_0.qg(numberToInt(v));
            else {
              this_0.sg(v);
            }
          }
           while (inductionVariable_0 < 4);
        this_0.nb(' ],\n');
      }
       while (inductionVariable < 4);
    this_0.nb(')');
    return this_0.toString();
  }
}
class Companion_9 {
  constructor() {
    this.a26_1 = 1.0E-7;
  }
  b26(up) {
    // Inline function 'kotlin.check' call
    var tmp;
    if (up.c26_1 === 0.0) {
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = up.d26_1;
      tmp = Math.abs(this_0) === 1.0;
    } else {
      tmp = false;
    }
    // Inline function 'kotlin.contracts.contract' call
    if (!tmp) {
      // Inline function 'korlibs.math.geom.Companion.checkValidUpVector.<anonymous>' call
      var message = 'up vector only supports (0, -1) and (0, +1) for now';
      throw IllegalStateException.s4(toString(message));
    }
  }
}
class Orientation extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.c2e_1 = value;
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_10 = this;
    var tmp = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_10();
    tmp.d2e_1 = new RectCorners(numberToDouble(0), numberToDouble(0), numberToDouble(0), numberToDouble(0));
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_10();
    tmp_0.e2e_1 = new RectCorners(numberToDouble(0), numberToDouble(0), numberToDouble(0), numberToDouble(0));
    var tmp_1 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_10();
    tmp_1.f2e_1 = new RectCorners(numberToDouble(1.0), numberToDouble(1.0), numberToDouble(1.0), numberToDouble(1.0));
    var tmp_2 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_10();
    var corner = -1.0;
    tmp_2.g2e_1 = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
    var tmp_3 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_10();
    tmp_3.h2e_1 = new RectCorners(numberToDouble(NaN), numberToDouble(NaN), numberToDouble(NaN), numberToDouble(NaN));
  }
}
class RectCorners {
  constructor(topLeft, topRight, bottomRight, bottomLeft) {
    Companion_getInstance_10();
    this.i2e_1 = topLeft;
    this.j2e_1 = topRight;
    this.k2e_1 = bottomRight;
    this.l2e_1 = bottomLeft;
  }
  toString() {
    return 'RectCorners(topLeft=' + this.i2e_1 + ', topRight=' + this.j2e_1 + ', bottomRight=' + this.k2e_1 + ', bottomLeft=' + this.l2e_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.i2e_1);
    result = imul(result, 31) + getNumberHashCode(this.j2e_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.k2e_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.l2e_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectCorners))
      return false;
    var tmp0_other_with_cast = other instanceof RectCorners ? other : THROW_CCE();
    if (!equals(this.i2e_1, tmp0_other_with_cast.i2e_1))
      return false;
    if (!equals(this.j2e_1, tmp0_other_with_cast.j2e_1))
      return false;
    if (!equals(this.k2e_1, tmp0_other_with_cast.k2e_1))
      return false;
    if (!equals(this.l2e_1, tmp0_other_with_cast.l2e_1))
      return false;
    return true;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_11 = this;
    this.y26_1 = Companion_getInstance_11().m2e(0, 0, 0, 0);
    this.z26_1 = Companion_getInstance_11().n2e(-Infinity, -Infinity, Infinity, Infinity);
    this.a27_1 = Companion_getInstance_11().n2e(NaN, NaN, 0.0, 0.0);
  }
  b27() {
    return this.a27_1;
  }
  q29() {
    return this.y26_1;
  }
  k27(p, s) {
    return new Rectangle(p.c26_1, p.d26_1, s.h27_1, s.i27_1);
  }
  m2e(x, y, width, height) {
    return Companion_getInstance_11().k27(Vector2D.y28(x, y), Size2D.j27(width, height));
  }
  n2e(x, y, width, height) {
    return Companion_getInstance_11().k27(Vector2D.y2a(x, y), Size2D.o2e(width, height));
  }
  p2e(left, top, right, bottom) {
    return new Rectangle(left, top, right - left, bottom - top);
  }
  q2e(left, top, right, bottom) {
    return this.p2e(left, top, right, bottom);
  }
  g27(point1, point2) {
    var tmp = Companion_getInstance_11();
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var tmp$ret$0 = Vector2D.l28(point2.c26_1 - point1.c26_1, point2.d26_1 - point1.d26_1);
    return tmp.k27(point1, toSize(tmp$ret$0));
  }
  r2e(a, b) {
    return a.m26_1 >= b.m26_1 && a.n26_1 >= b.n26_1 && a.m26_1 + a.o26_1 <= b.m26_1 + b.o26_1 && a.n26_1 + a.p26_1 <= b.n26_1 + b.p26_1;
  }
}
class Rectangle {
  constructor(x, y, width, height) {
    Companion_getInstance_11();
    this.m26_1 = x;
    this.n26_1 = y;
    this.o26_1 = width;
    this.p26_1 = height;
    this.q26_1 = true;
  }
  u1i() {
    return this;
  }
  d1() {
    return Size2D.s2e(this.o26_1, this.p26_1);
  }
  t2e() {
    return isNaN_0(this.m26_1);
  }
  r26() {
    return this.t2e();
  }
  s26() {
    return !this.r26();
  }
  u2e(other, epsilon) {
    return isAlmostEquals(this.m26_1, other.m26_1, epsilon) && isAlmostEquals(this.n26_1, other.n26_1, epsilon) && isAlmostEquals(this.o26_1, other.o26_1, epsilon) && isAlmostEquals(this.p26_1, other.p26_1, epsilon);
  }
  c1i(other, epsilon) {
    return this.u2e(other instanceof Rectangle ? other : THROW_CCE(), epsilon);
  }
  toString() {
    return this.r26() ? 'null' : 'Rectangle(x=' + get_niceStr(this.m26_1) + ', y=' + get_niceStr(this.n26_1) + ', width=' + get_niceStr(this.o26_1) + ', height=' + get_niceStr(this.p26_1) + ')';
  }
  v2e(scale) {
    return new Rectangle(this.m26_1 * scale, this.n26_1 * scale, this.o26_1 * scale, this.p26_1 * scale);
  }
  i28(that) {
    return this.w2e(that.c26_1, that.d26_1);
  }
  w2e(x, y) {
    return x >= this.t26() && x < this.u26() && (y >= this.v26() && y < this.w26());
  }
  t26() {
    return this.m26_1;
  }
  v26() {
    return this.n26_1;
  }
  u26() {
    return this.m26_1 + this.o26_1;
  }
  w26() {
    return this.n26_1 + this.p26_1;
  }
  l27() {
    return Vector2D.l28(this.t26(), this.v26());
  }
  x2e() {
    return Vector2D.l28(this.u26(), this.v26());
  }
  y2e() {
    return Vector2D.l28(this.t26(), this.w26());
  }
  n27() {
    return Vector2D.l28(this.u26(), this.w26());
  }
  z2e() {
    return (this.u26() + this.t26()) * 0.5;
  }
  a2f() {
    return (this.w26() + this.v26()) * 0.5;
  }
  b2f() {
    return Vector2D.l28(this.z2e(), this.a2f());
  }
  c2f(that) {
    return this.d2f(that) && this.e2f(that);
  }
  d2f(that) {
    return that.t26() <= this.u26() && that.u26() >= this.t26();
  }
  e2f(that) {
    return that.v26() <= this.w26() && that.w26() >= this.v26();
  }
  f2f(that) {
    var tmp;
    if (this.c2f(that)) {
      // Inline function 'kotlin.math.max' call
      var a = this.t26();
      var b = that.t26();
      var tmp_0 = Math.max(a, b);
      // Inline function 'kotlin.math.max' call
      var a_0 = this.v26();
      var b_0 = that.v26();
      var tmp_1 = Math.max(a_0, b_0);
      // Inline function 'kotlin.math.min' call
      var a_1 = this.u26();
      var b_1 = that.u26();
      var tmp_2 = Math.min(a_1, b_1);
      // Inline function 'kotlin.math.min' call
      var a_2 = this.w26();
      var b_2 = that.w26();
      var tmp$ret$3 = Math.min(a_2, b_2);
      tmp = new Rectangle(tmp_0, tmp_1, tmp_2, tmp$ret$3);
    } else {
      tmp = Companion_getInstance_11().b27();
    }
    return tmp;
  }
  f2() {
    return RectangleInt.k2f(numberToInt(this.m26_1), numberToInt(this.n26_1), numberToInt(this.o26_1), numberToInt(this.p26_1));
  }
  l2f(border) {
    return Companion_getInstance_11().p2e(this.t26() - border.h29_1, this.v26() - border.e29_1, this.u26() + border.f29_1, this.w26() + border.g29_1);
  }
  t2a(delta) {
    return this.m2f(this.m26_1 + delta.c26_1, this.n26_1 + delta.d26_1);
  }
  n2f(m) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p = this.l27();
      if (m.r26()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.l28(m.i2a(p.c26_1, p.d26_1), m.l2a(p.c26_1, p.d26_1));
    }
    var tl = tmp$ret$0;
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_0 = this.x2e();
      if (m.r26()) {
        tmp$ret$1 = p_0;
        break $l$block_0;
      }
      tmp$ret$1 = Vector2D.l28(m.i2a(p_0.c26_1, p_0.d26_1), m.l2a(p_0.c26_1, p_0.d26_1));
    }
    var tr = tmp$ret$1;
    var tmp$ret$2;
    $l$block_1: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_1 = this.y2e();
      if (m.r26()) {
        tmp$ret$2 = p_1;
        break $l$block_1;
      }
      tmp$ret$2 = Vector2D.l28(m.i2a(p_1.c26_1, p_1.d26_1), m.l2a(p_1.c26_1, p_1.d26_1));
    }
    var bl = tmp$ret$2;
    var tmp$ret$3;
    $l$block_2: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_2 = this.n27();
      if (m.r26()) {
        tmp$ret$3 = p_2;
        break $l$block_2;
      }
      tmp$ret$3 = Vector2D.l28(m.i2a(p_2.c26_1, p_2.d26_1), m.l2a(p_2.c26_1, p_2.d26_1));
    }
    var br = tmp$ret$3;
    var min = Companion_getInstance_17().e27(tl, tr, bl, br);
    var max = Companion_getInstance_17().f27(tl, tr, bl, br);
    return Companion_getInstance_11().g27(min, max);
  }
  o2f() {
    return Companion_getInstance_11().g27(Companion_getInstance_17().m27(this.l27(), this.n27()), Companion_getInstance_17().o27(this.l27(), this.n27()));
  }
  p2f(x, y, width, height) {
    return new Rectangle(x, y, width, height);
  }
  m2f(x, y, width, height, $super) {
    x = x === VOID ? this.m26_1 : x;
    y = y === VOID ? this.n26_1 : y;
    width = width === VOID ? this.o26_1 : width;
    height = height === VOID ? this.p26_1 : height;
    return $super === VOID ? this.p2f(x, y, width, height) : $super.p2f.call(this, x, y, width, height);
  }
  hashCode() {
    var result = getNumberHashCode(this.m26_1);
    result = imul(result, 31) + getNumberHashCode(this.n26_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o26_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p26_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Rectangle))
      return false;
    var tmp0_other_with_cast = other instanceof Rectangle ? other : THROW_CCE();
    if (!equals(this.m26_1, tmp0_other_with_cast.m26_1))
      return false;
    if (!equals(this.n26_1, tmp0_other_with_cast.n26_1))
      return false;
    if (!equals(this.o26_1, tmp0_other_with_cast.o26_1))
      return false;
    if (!equals(this.p26_1, tmp0_other_with_cast.p26_1))
      return false;
    return true;
  }
}
class Companion_12 {
  r2f(a, b) {
    // Inline function 'kotlin.math.min' call
    var a_0 = a.t26();
    var b_0 = b.t26();
    var tmp = Math.min(a_0, b_0);
    // Inline function 'kotlin.math.min' call
    var a_1 = a.v26();
    var b_1 = b.v26();
    var tmp_0 = Math.min(a_1, b_1);
    // Inline function 'kotlin.math.max' call
    var a_2 = a.u26();
    var b_2 = b.u26();
    var tmp_1 = Math.max(a_2, b_2);
    // Inline function 'kotlin.math.max' call
    var a_3 = a.w26();
    var b_3 = b.w26();
    var tmp$ret$3 = Math.max(a_3, b_3);
    return this.q2e(tmp, tmp_0, tmp_1, tmp$ret$3);
  }
  s2f(topLeft, bottomRight) {
    var size = bottomRight.v2f(topLeft);
    return RectangleInt.k2f(topLeft.t2f_1, topLeft.u2f_1, size.t2f_1, size.u2f_1);
  }
  q2e(left, top, right, bottom) {
    return this.s2f(Vector2I.w2f(left, top), Vector2I.w2f(right, bottom));
  }
}
class RectangleInt {
  static k2f(x, y, width, height) {
    var $this = createThis(this);
    $this.g2f_1 = x;
    $this.h2f_1 = y;
    $this.i2f_1 = width;
    $this.j2f_1 = height;
    return $this;
  }
  static x2f() {
    return this.k2f(0, 0, 0, 0);
  }
  y2f() {
    return imul(this.i2f_1, this.j2f_1);
  }
  t26() {
    return this.g2f_1;
  }
  v26() {
    return this.h2f_1;
  }
  u26() {
    return this.g2f_1 + this.i2f_1 | 0;
  }
  w26() {
    return this.h2f_1 + this.j2f_1 | 0;
  }
  z2f(left, top, right, bottom, clamped) {
    var left_0 = !clamped ? left : coerceIn(left, 0, this.i2f_1);
    var right_0 = !clamped ? right : coerceIn(right, 0, this.i2f_1);
    var top_0 = !clamped ? top : coerceIn(top, 0, this.j2f_1);
    var bottom_0 = !clamped ? bottom : coerceIn(bottom, 0, this.j2f_1);
    return Companion_instance_12.q2e(this.g2f_1 + left_0 | 0, this.h2f_1 + top_0 | 0, this.g2f_1 + right_0 | 0, this.h2f_1 + bottom_0 | 0);
  }
  toString() {
    return 'Rectangle(x=' + this.g2f_1 + ', y=' + this.h2f_1 + ', width=' + this.i2f_1 + ', height=' + this.j2f_1 + ')';
  }
  a2g() {
    return Companion_getInstance_11().m2e(this.g2f_1, this.h2f_1, this.i2f_1, this.j2f_1);
  }
  l2f(border) {
    return Companion_instance_12.q2e(this.t26() - border.h29_1 | 0, this.v26() - border.e29_1 | 0, this.u26() + border.f29_1 | 0, this.w26() + border.g29_1 | 0);
  }
  hashCode() {
    var result = this.g2f_1;
    result = imul(result, 31) + this.h2f_1 | 0;
    result = imul(result, 31) + this.i2f_1 | 0;
    result = imul(result, 31) + this.j2f_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectangleInt))
      return false;
    var tmp0_other_with_cast = other instanceof RectangleInt ? other : THROW_CCE();
    if (!(this.g2f_1 === tmp0_other_with_cast.g2f_1))
      return false;
    if (!(this.h2f_1 === tmp0_other_with_cast.h2f_1))
      return false;
    if (!(this.i2f_1 === tmp0_other_with_cast.i2f_1))
      return false;
    if (!(this.j2f_1 === tmp0_other_with_cast.j2f_1))
      return false;
    return true;
  }
}
class Companion_13 {}
class RoundRectangle {
  constructor(rect, corners) {
    this.b2g_1 = rect;
    this.c2g_1 = corners;
  }
  toString() {
    return 'RoundRectangle(rect=' + this.b2g_1.toString() + ', corners=' + this.c2g_1.toString() + ')';
  }
  hashCode() {
    var result = this.b2g_1.hashCode();
    result = imul(result, 31) + this.c2g_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RoundRectangle))
      return false;
    var tmp0_other_with_cast = other instanceof RoundRectangle ? other : THROW_CCE();
    if (!this.b2g_1.equals(tmp0_other_with_cast.b2g_1))
      return false;
    if (!this.c2g_1.equals(tmp0_other_with_cast.c2g_1))
      return false;
    return true;
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_14 = this;
    this.d2g_1 = Scale.e2g(1.0, 1.0);
  }
}
class Scale {
  static z2d(scaleX, scaleY) {
    Companion_getInstance_14();
    var $this = createThis(this);
    $this.x2d_1 = scaleX;
    $this.y2d_1 = scaleY;
    return $this;
  }
  b2c() {
    return this.x2d_1 * 0.5 + this.y2d_1 * 0.5;
  }
  static f2g() {
    Companion_getInstance_14();
    return this.e2g(1.0, 1.0);
  }
  static g2g(scale) {
    Companion_getInstance_14();
    return this.z2d(scale, scale);
  }
  static h2g(scale) {
    Companion_getInstance_14();
    return this.g2g(scale);
  }
  static e2g(scaleX, scaleY) {
    Companion_getInstance_14();
    return this.z2d(scaleX, scaleY);
  }
  static i2g(scaleX, scaleY) {
    Companion_getInstance_14();
    return this.z2d(scaleX, scaleY);
  }
  toString() {
    return 'Scale(scaleX=' + this.x2d_1 + ', scaleY=' + this.y2d_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.x2d_1);
    result = imul(result, 31) + getNumberHashCode(this.y2d_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Scale))
      return false;
    var tmp0_other_with_cast = other instanceof Scale ? other : THROW_CCE();
    if (!equals(this.x2d_1, tmp0_other_with_cast.x2d_1))
      return false;
    if (!equals(this.y2d_1, tmp0_other_with_cast.y2d_1))
      return false;
    return true;
  }
}
class Companion_15 {
  constructor() {
    Companion_instance_15 = this;
    var tmp = this;
    tmp.m2g_1 = new ScaleMode('COVER', ScaleMode$Companion$COVER$lambda);
    var tmp_0 = this;
    tmp_0.n2g_1 = new ScaleMode('SHOW_ALL', ScaleMode$Companion$SHOW_ALL$lambda);
    var tmp_1 = this;
    tmp_1.o2g_1 = new ScaleMode('EXACT', ScaleMode$Companion$EXACT$lambda);
    var tmp_2 = this;
    tmp_2.p2g_1 = new ScaleMode('NO_SCALE', ScaleMode$Companion$NO_SCALE$lambda);
  }
  q2g() {
    return this.o2g_1;
  }
}
class ScaleMode {
  constructor(name, transform) {
    Companion_getInstance_15();
    name = name === VOID ? null : name;
    this.r2g_1 = name;
    this.s2g_1 = transform;
  }
  toString() {
    return 'ScaleMode(' + this.r2g_1 + ')';
  }
  t2g(item, container) {
    return toInt(this.s2g_1(toFloat(item), toFloat(container)));
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_16 = this;
    this.u2g_1 = Size2D.s2e(0.0, 0.0);
  }
}
class Size2D {
  static s2e(width, height) {
    Companion_getInstance_16();
    var $this = createThis(this);
    $this.h27_1 = width;
    $this.i27_1 = height;
    return $this;
  }
  static v2g() {
    Companion_getInstance_16();
    return this.s2e(0.0, 0.0);
  }
  static o2e(width, height) {
    Companion_getInstance_16();
    return this.s2e(width, height);
  }
  static j27(width, height) {
    Companion_getInstance_16();
    return this.s2e(width, height);
  }
  w2g(scale) {
    return Size2D.s2e(this.h27_1 * scale.x2d_1, this.i27_1 * scale.y2d_1);
  }
  x2g(s) {
    return Size2D.s2e(this.h27_1 * s, this.i27_1 * s);
  }
  v2e(s) {
    return this.x2g(s);
  }
  y2g(s) {
    return this.x2g(s);
  }
  j2g(other) {
    return Scale.z2d(this.h27_1 / other.h27_1, this.i27_1 / other.i27_1);
  }
  toString() {
    return 'Size(width=' + get_niceStr(this.h27_1) + ', height=' + get_niceStr(this.i27_1) + ')';
  }
  bl() {
    return this.h27_1;
  }
  cl() {
    return this.i27_1;
  }
  z2g(width, height) {
    return Size2D.s2e(width, height);
  }
  a2h(width, height, $super) {
    width = width === VOID ? this.h27_1 : width;
    height = height === VOID ? this.i27_1 : height;
    return $super === VOID ? this.z2g(width, height) : $super.z2g.call(this, width, height);
  }
  hashCode() {
    var result = getNumberHashCode(this.h27_1);
    result = imul(result, 31) + getNumberHashCode(this.i27_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Size2D))
      return false;
    var tmp0_other_with_cast = other instanceof Size2D ? other : THROW_CCE();
    if (!equals(this.h27_1, tmp0_other_with_cast.h27_1))
      return false;
    if (!equals(this.i27_1, tmp0_other_with_cast.i27_1))
      return false;
    return true;
  }
}
class SizeInt {
  static d2h(width, height) {
    var $this = createThis(this);
    $this.b2h_1 = width;
    $this.c2h_1 = height;
    return $this;
  }
  static e2h() {
    return this.d2h(0, 0);
  }
  toString() {
    return '' + this.b2h_1 + 'x' + this.c2h_1;
  }
  hashCode() {
    var result = this.b2h_1;
    result = imul(result, 31) + this.c2h_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SizeInt))
      return false;
    var tmp0_other_with_cast = other instanceof SizeInt ? other : THROW_CCE();
    if (!(this.b2h_1 === tmp0_other_with_cast.b2h_1))
      return false;
    if (!(this.c2h_1 === tmp0_other_with_cast.c2h_1))
      return false;
    return true;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_17 = this;
    this.e26_1 = Vector2D.l28(0.0, 0.0);
    this.f26_1 = Vector2D.l28(NaN, NaN);
    this.g26_1 = Vector2D.l28(-1.0, 0.0);
    this.h26_1 = Vector2D.l28(+1.0, 0.0);
    this.i26_1 = Vector2D.l28(0.0, +1.0);
    this.j26_1 = Vector2D.l28(0.0, -1.0);
    this.k26_1 = Vector2D.l28(0.0, -1.0);
    this.l26_1 = Vector2D.l28(0.0, +1.0);
  }
  f2h(a, b, up) {
    // Inline function 'korlibs.math.geom.Companion.between' call
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var x0 = a.c26_1;
    var y0 = a.d26_1;
    var x1 = b.c26_1;
    var y1 = b.d26_1;
    return Angle_between(x0, y0, x1, y1, up);
  }
  g2h(a, b, up, $super) {
    up = up === VOID ? this.i26_1 : up;
    return $super === VOID ? this.f2h(a, b, up) : $super.f2h.call(this, a, b, up).r25_1;
  }
  h2h(a, b, up) {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    // Inline function 'kotlin.math.acos' call
    var x = a.i2h(b) / (a.a() * b.a());
    var radians = Math.acos(x);
    var tmp$ret$1 = _Angle___init__impl__g23q1m(radians);
    return adjustFromUp(tmp$ret$1, up);
  }
  j2h(a, b, up, $super) {
    up = up === VOID ? this.i26_1 : up;
    return $super === VOID ? this.h2h(a, b, up) : $super.h2h.call(this, a, b, up).r25_1;
  }
  q2f(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  k2h(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  l2h(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  m2h(a, b) {
    return this.q2f(a.c26_1, a.d26_1, b.c26_1, b.d26_1);
  }
  u27(a, b) {
    return this.n2h(a.c26_1, a.d26_1, b.c26_1, b.d26_1);
  }
  n2h(x1, y1, x2, y2) {
    return square(this, x1 - x2) + square(this, y1 - y2);
  }
  o2h(ax, ay, bx, by) {
    return ax * by - bx * ay;
  }
  p2h(p1, p2) {
    return this.o2h(p1.c26_1, p1.d26_1, p2.c26_1, p2.d26_1);
  }
  m27(p1, p2) {
    // Inline function 'kotlin.math.min' call
    var a = p1.c26_1;
    var b = p2.c26_1;
    var tmp = Math.min(a, b);
    // Inline function 'kotlin.math.min' call
    var a_0 = p1.d26_1;
    var b_0 = p2.d26_1;
    var tmp$ret$1 = Math.min(a_0, b_0);
    return Vector2D.l28(tmp, tmp$ret$1);
  }
  e27(p1, p2, p3, p4) {
    return Vector2D.l28(minOf(p1.c26_1, new Float64Array([p2.c26_1, p3.c26_1, p4.c26_1])), minOf(p1.d26_1, new Float64Array([p2.d26_1, p3.d26_1, p4.d26_1])));
  }
  o27(p1, p2) {
    // Inline function 'kotlin.math.max' call
    var a = p1.c26_1;
    var b = p2.c26_1;
    var tmp = Math.max(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = p1.d26_1;
    var b_0 = p2.d26_1;
    var tmp$ret$1 = Math.max(a_0, b_0);
    return Vector2D.l28(tmp, tmp$ret$1);
  }
  f27(p1, p2, p3, p4) {
    return Vector2D.l28(maxOf(p1.c26_1, new Float64Array([p2.c26_1, p3.c26_1, p4.c26_1])), maxOf(p1.d26_1, new Float64Array([p2.d26_1, p3.d26_1, p4.d26_1])));
  }
}
class Vector2D {
  static l28(x, y) {
    Companion_getInstance_17();
    var $this = createThis(this);
    $this.c26_1 = x;
    $this.d26_1 = y;
    return $this;
  }
  static y2a(x, y) {
    Companion_getInstance_17();
    return this.l28(x, y);
  }
  static y28(x, y) {
    Companion_getInstance_17();
    return this.l28(x, y);
  }
  static w28() {
    Companion_getInstance_17();
    return this.l28(0.0, 0.0);
  }
  l2g() {
    // Inline function 'kotlin.math.min' call
    var a = this.c26_1;
    var b = this.d26_1;
    return Math.min(a, b);
  }
  k2g() {
    // Inline function 'kotlin.math.max' call
    var a = this.c26_1;
    var b = this.d26_1;
    return Math.max(a, b);
  }
  q2h(x, y) {
    // Inline function 'kotlin.math.hypot' call
    var x_0 = x - this.c26_1;
    var y_0 = y - this.d26_1;
    return hypot(x_0, y_0);
  }
  r2h(that) {
    return this.q2h(that.c26_1, that.d26_1);
  }
  i2h(that) {
    return this.c26_1 * that.c26_1 + this.d26_1 * that.d26_1;
  }
  a() {
    // Inline function 'kotlin.math.hypot' call
    var x = this.c26_1;
    var y = this.d26_1;
    return hypot(x, y);
  }
  s2h() {
    var x = this.c26_1;
    var y = this.d26_1;
    return x * x + y * y;
  }
  t2h() {
    // Inline function 'kotlin.math.hypot' call
    var x = this.c26_1;
    var y = this.d26_1;
    return hypot(x, y);
  }
  u2h() {
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale = 1.0 / this.t2h();
    return Vector2D.l28(this.c26_1 * scale, this.d26_1 * scale);
  }
  v2h() {
    // Inline function 'korlibs.math.geom.Vector2D.div' call
    var scale = this.a();
    return Vector2D.l28(this.c26_1 / scale, this.d26_1 / scale);
  }
  w2h() {
    return Vector2D.l28(-this.d26_1, this.c26_1);
  }
  x2h(other, epsilon) {
    return isAlmostEquals(this.c26_1, other.c26_1, epsilon) && isAlmostEquals(this.d26_1, other.d26_1, epsilon);
  }
  c1i(other, epsilon) {
    return this.x2h(other instanceof Vector2D ? other : THROW_CCE(), epsilon);
  }
  y2h() {
    return '(' + get_niceStr(this.c26_1) + ', ' + get_niceStr(this.d26_1) + ')';
  }
  toString() {
    return this.y2h();
  }
  bl() {
    return this.c26_1;
  }
  cl() {
    return this.d26_1;
  }
  hashCode() {
    var result = getNumberHashCode(this.c26_1);
    result = imul(result, 31) + getNumberHashCode(this.d26_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2D))
      return false;
    var tmp0_other_with_cast = other instanceof Vector2D ? other : THROW_CCE();
    if (!equals(this.c26_1, tmp0_other_with_cast.c26_1))
      return false;
    if (!equals(this.d26_1, tmp0_other_with_cast.d26_1))
      return false;
    return true;
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_18 = this;
    this.z2h_1 = new Vector4F(0.0, 0.0, 0.0, 0.0);
    this.a2i_1 = new Vector4F(1.0, 1.0, 1.0, 1.0);
  }
}
class Vector4F {
  constructor(x, y, z, w) {
    Companion_getInstance_18();
    this.b2i_1 = x;
    this.c2i_1 = y;
    this.d2i_1 = z;
    this.e2i_1 = w;
  }
  toString() {
    return 'Vector4(' + get_niceStr_0(this.b2i_1) + ', ' + get_niceStr_0(this.c2i_1) + ', ' + get_niceStr_0(this.d2i_1) + ', ' + get_niceStr_0(this.e2i_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.b2i_1);
    result = imul(result, 31) + getNumberHashCode(this.c2i_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d2i_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e2i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector4F))
      return false;
    var tmp0_other_with_cast = other instanceof Vector4F ? other : THROW_CCE();
    if (!equals(this.b2i_1, tmp0_other_with_cast.b2i_1))
      return false;
    if (!equals(this.c2i_1, tmp0_other_with_cast.c2i_1))
      return false;
    if (!equals(this.d2i_1, tmp0_other_with_cast.d2i_1))
      return false;
    if (!equals(this.e2i_1, tmp0_other_with_cast.e2i_1))
      return false;
    return true;
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_19 = this;
    this.f2i_1 = new Vector3F(NaN, NaN, NaN);
    this.g2i_1 = new Vector3F(0.0, 0.0, 0.0);
    this.h2i_1 = new Vector3F(1.0, 1.0, 1.0);
    this.i2i_1 = new Vector3F(0.0, 0.0, 1.0);
    this.j2i_1 = new Vector3F(0.0, 0.0, -1.0);
    this.k2i_1 = new Vector3F(-1.0, 0.0, 0.0);
    this.l2i_1 = new Vector3F(1.0, 0.0, 0.0);
    this.m2i_1 = new Vector3F(0.0, 1.0, 0.0);
    this.n2i_1 = new Vector3F(0.0, -1.0, 0.0);
  }
}
class Vector3F {
  constructor(x, y, z) {
    Companion_getInstance_19();
    this.o2i_1 = x;
    this.p2i_1 = y;
    this.q2i_1 = z;
  }
  toString() {
    return 'Vector3(' + get_niceStr_0(this.o2i_1) + ', ' + get_niceStr_0(this.p2i_1) + ', ' + get_niceStr_0(this.q2i_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.o2i_1);
    result = imul(result, 31) + getNumberHashCode(this.p2i_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q2i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector3F))
      return false;
    var tmp0_other_with_cast = other instanceof Vector3F ? other : THROW_CCE();
    if (!equals(this.o2i_1, tmp0_other_with_cast.o2i_1))
      return false;
    if (!equals(this.p2i_1, tmp0_other_with_cast.p2i_1))
      return false;
    if (!equals(this.q2i_1, tmp0_other_with_cast.q2i_1))
      return false;
    return true;
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_20 = this;
    this.r2i_1 = Vector2I.w2f(0, 0);
  }
}
class Vector2I {
  static w2f(x, y) {
    Companion_getInstance_20();
    var $this = createThis(this);
    $this.t2f_1 = x;
    $this.u2f_1 = y;
    return $this;
  }
  static s2i() {
    Companion_getInstance_20();
    return this.w2f(0, 0);
  }
  v2f(that) {
    return Vector2I.w2f(this.t2f_1 - that.t2f_1 | 0, this.u2f_1 - that.u2f_1 | 0);
  }
  toString() {
    return '(' + this.t2f_1 + ', ' + this.u2f_1 + ')';
  }
  hashCode() {
    var result = this.t2f_1;
    result = imul(result, 31) + this.u2f_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2I))
      return false;
    var tmp0_other_with_cast = other instanceof Vector2I ? other : THROW_CCE();
    if (!(this.t2f_1 === tmp0_other_with_cast.t2f_1))
      return false;
    if (!(this.u2f_1 === tmp0_other_with_cast.u2f_1))
      return false;
    return true;
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function _Angle___init__impl__g23q1m(radians) {
  return radians;
}
function _Angle___get_radians__impl__n00yt5($this) {
  return $this;
}
function _Angle___get_ratio__impl__ap3on4($this) {
  // Inline function 'korlibs.math.geom.Companion.radiansToRatio' call
  Companion_getInstance_0();
  var radians = _Angle___get_radians__impl__n00yt5($this);
  return _Ratio___init__impl__9mwvn2(radians / 6.283185307179586);
}
function _Angle___get_degrees__impl__qg56vw($this) {
  // Inline function 'korlibs.math.geom.Companion.radiansToDegrees' call
  Companion_getInstance_0();
  return _Angle___get_radians__impl__n00yt5($this) * 57.29577951308232;
}
function _Angle___get_cosine__impl__vprvmu($this) {
  // Inline function 'kotlin.math.cos' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.cos(x);
}
function _Angle___get_sine__impl__15nmyi($this) {
  // Inline function 'kotlin.math.sin' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.sin(x);
}
function _Angle___get_tangent__impl__vushdy($this) {
  // Inline function 'kotlin.math.tan' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.tan(x);
}
function Angle__cosine_impl_bgvzun($this, up) {
  return _Angle___get_cosine__impl__vprvmu(adjustFromUp($this, up));
}
function Angle__sine_impl_3l11xv($this, up) {
  return _Angle___get_sine__impl__15nmyi(adjustFromUp($this, up));
}
function _Angle___get_absoluteValue__impl__4qoakv($this) {
  // Inline function 'kotlin.math.absoluteValue' call
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var this_0 = _Angle___get_radians__impl__n00yt5($this);
  var tmp$ret$1 = Math.abs(this_0);
  return _Angle___init__impl__g23q1m(tmp$ret$1);
}
function Angle__times_impl_v3s9y2($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 * scale);
}
function Angle__div_impl_ut2btd($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 / scale);
}
function Angle__times_impl_v3s9y2_0($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 * scale);
}
function Angle__umod_impl_4wilf7($this, angle) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(angle);
  return _Angle___init__impl__g23q1m(umod(tmp, tmp$ret$1));
}
function Angle__div_impl_ut2btd_0($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  return tmp / _Angle___get_radians__impl__n00yt5(other);
}
function Angle__plus_impl_26v37k($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(other);
  return _Angle___init__impl__g23q1m(tmp + tmp$ret$1);
}
function Angle__minus_impl_xeau7k($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(other);
  return _Angle___init__impl__g23q1m(tmp - tmp$ret$1);
}
function Angle__unaryMinus_impl_7901fr($this) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(-tmp$ret$0);
}
function Angle__unaryPlus_impl_eyi5pl($this) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(+tmp$ret$0);
}
function Angle__isAlmostEquals_impl_201sgt($this, other, epsilon) {
  return isAlmostEquals(_Angle___get_radians__impl__n00yt5($this), _Angle___get_radians__impl__n00yt5(other), epsilon);
}
function Angle__isAlmostEquals_impl_201sgt_0($this, other, epsilon) {
  return Angle__isAlmostEquals_impl_201sgt($this.r25_1, other instanceof Angle ? other.r25_1 : THROW_CCE(), epsilon);
}
function _Angle___get_normalized__impl__9s30ys($this) {
  // Inline function 'korlibs.math.geom.Companion.fromRatio' call
  Companion_getInstance_0();
  var ratio = umod(Ratio__toDouble_impl_o7epze(_Angle___get_ratio__impl__ap3on4($this)), 1.0);
  // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
  var ratio_0 = toRatio(ratio);
  var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
  return _Angle___init__impl__g23q1m(tmp$ret$0);
}
function Angle__compareTo_impl_a0hfds($this, other) {
  return Ratio__compareTo_impl_z2ienc(_Angle___get_ratio__impl__ap3on4($this), _Angle___get_ratio__impl__ap3on4(other));
}
function Angle__compareTo_impl_a0hfds_0($this, other) {
  return Angle__compareTo_impl_a0hfds($this.r25_1, other instanceof Angle ? other.r25_1 : THROW_CCE());
}
function Angle__toString_impl_786qky($this) {
  return get_niceStr(roundDecimalPlaces(_Angle___get_degrees__impl__qg56vw($this), 2)) + '.degrees';
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function Angle__hashCode_impl_szcndt($this) {
  return getNumberHashCode($this);
}
function Angle__equals_impl_zcf5mt($this, other) {
  if (!(other instanceof Angle))
    return false;
  var tmp0_other_with_cast = other instanceof Angle ? other.r25_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function get_degrees(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromDegrees' call
  // Inline function 'korlibs.math.geom.Companion.degreesToRadians' call
  Companion_getInstance_0();
  var tmp$ret$0 = _this__u8e3s4 * 0.017453292519943295;
  return _Angle___init__impl__g23q1m(tmp$ret$0);
}
function get_radians(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  Companion_getInstance_0();
  return _Angle___init__impl__g23q1m(_this__u8e3s4);
}
function interpolateAngleDenormalized(_this__u8e3s4, l, r) {
  return interpolateAngle(_this__u8e3s4, l, r, false);
}
function get_radians_0(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  Companion_getInstance_0();
  return _Angle___init__impl__g23q1m(_this__u8e3s4);
}
function get_degrees_0(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromDegrees' call
  // Inline function 'korlibs.math.geom.Companion.degreesToRadians' call
  Companion_getInstance_0();
  var tmp$ret$0 = _this__u8e3s4 * 0.017453292519943295;
  return _Angle___init__impl__g23q1m(tmp$ret$0);
}
function adjustFromUp(_this__u8e3s4, up) {
  Companion_instance_9.b26(up);
  return up.d26_1 > 0 ? _this__u8e3s4 : Angle__unaryMinus_impl_7901fr(_this__u8e3s4);
}
function Angle_between(x0, y0, x1, y1, up) {
  up = up === VOID ? Companion_getInstance_17().i26_1 : up;
  // Inline function 'korlibs.math.geom.Companion.atan2' call
  Companion_getInstance_0();
  var x = y1 - y0;
  var y = x1 - x0;
  var up_0 = Companion_getInstance_17().i26_1;
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  // Inline function 'kotlin.math.atan2' call
  var radians = Math.atan2(x, y);
  var tmp$ret$1 = _Angle___init__impl__g23q1m(radians);
  var angle = adjustFromUp(tmp$ret$1, up_0);
  return adjustFromUp(Angle__compareTo_impl_a0hfds(angle, Companion_getInstance_0().t25_1) < 0 ? Angle__plus_impl_26v37k(angle, Companion_getInstance_0().x25_1) : angle, up);
}
function interpolateAngle(_this__u8e3s4, l, r, minimizeAngle) {
  return _interpolateAngleAny(_this__u8e3s4, l, r, minimizeAngle);
}
function _interpolateAngleAny(ratio, l, r, minimizeAngle) {
  minimizeAngle = minimizeAngle === VOID ? true : minimizeAngle;
  if (!minimizeAngle) {
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_0();
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_0 = interpolate(ratio, _Angle___get_ratio__impl__ap3on4(l), _Angle___get_ratio__impl__ap3on4(r));
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    return _Angle___init__impl__g23q1m(tmp$ret$0);
  }
  var ln = _Angle___get_normalized__impl__9s30ys(l);
  var rn = _Angle___get_normalized__impl__9s30ys(r);
  var tmp;
  if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(Angle__minus_impl_xeau7k(rn, ln)), Companion_getInstance_0().v25_1) <= 0) {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    var radians = interpolate_0(ratio, _Angle___get_radians__impl__n00yt5(ln), _Angle___get_radians__impl__n00yt5(rn));
    tmp = _Angle___init__impl__g23q1m(radians);
  } else if (Angle__compareTo_impl_a0hfds(ln, rn) < 0) {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    var radians_0 = interpolate_0(ratio, _Angle___get_radians__impl__n00yt5(Angle__plus_impl_26v37k(ln, Companion_getInstance_0().x25_1)), _Angle___get_radians__impl__n00yt5(rn));
    var tmp$ret$3 = _Angle___init__impl__g23q1m(radians_0);
    tmp = _Angle___get_normalized__impl__9s30ys(tmp$ret$3);
  } else {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    var radians_1 = interpolate_0(ratio, _Angle___get_radians__impl__n00yt5(ln), _Angle___get_radians__impl__n00yt5(Angle__plus_impl_26v37k(rn, Companion_getInstance_0().x25_1)));
    var tmp$ret$4 = _Angle___init__impl__g23q1m(radians_1);
    tmp = _Angle___get_normalized__impl__9s30ys(tmp$ret$4);
  }
  return tmp;
}
function _BoundsBuilder___init__impl__g6dprh(bounds) {
  return bounds;
}
function _BoundsBuilder___get_bounds__impl__s1l1gx($this) {
  return $this;
}
function _BoundsBuilder___get_isEmpty__impl__e9t785($this) {
  return _BoundsBuilder___get_bounds__impl__s1l1gx($this).r26();
}
function _BoundsBuilder___get_isNotEmpty__impl__w6rbsy($this) {
  return _BoundsBuilder___get_bounds__impl__s1l1gx($this).s26();
}
function _BoundsBuilder___get_xmin__impl__o2sib0($this) {
  // Inline function 'kotlin.math.min' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).t26();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).u26();
  return Math.min(a, b);
}
function _BoundsBuilder___get_xmax__impl__gsz0km($this) {
  // Inline function 'kotlin.math.max' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).t26();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).u26();
  return Math.max(a, b);
}
function _BoundsBuilder___get_ymin__impl__5n2e8j($this) {
  // Inline function 'kotlin.math.min' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).v26();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).w26();
  return Math.min(a, b);
}
function _BoundsBuilder___get_ymax__impl__oia4uz($this) {
  // Inline function 'kotlin.math.max' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).v26();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).w26();
  return Math.max(a, b);
}
function BoundsBuilder__xminOr_impl_k3l1m2($this, default_0) {
  return _BoundsBuilder___get_hasPoints__impl__6mwi9x($this) ? _BoundsBuilder___get_xmin__impl__o2sib0($this) : default_0;
}
function _BoundsBuilder___get_hasPoints__impl__6mwi9x($this) {
  return _BoundsBuilder___get_isNotEmpty__impl__w6rbsy($this);
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
function BoundsBuilder__plus_impl_cz7f7x($this, p) {
  if (_BoundsBuilder___get_bounds__impl__s1l1gx($this).r26())
    return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_11().k27(p, Size2D.j27(0, 0)));
  return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_11().g27(Companion_getInstance_17().m27(_BoundsBuilder___get_bounds__impl__s1l1gx($this).l27(), p), Companion_getInstance_17().o27(_BoundsBuilder___get_bounds__impl__s1l1gx($this).n27(), p)));
}
function BoundsBuilder__plus_impl_cz7f7x_0($this, rect) {
  if (rect == null)
    return $this;
  if (rect.r26())
    return $this;
  return BoundsBuilder__plus_impl_cz7f7x(BoundsBuilder__plus_impl_cz7f7x($this, rect.l27()), rect.n27());
}
function BoundsBuilder__plus_impl_cz7f7x_1($this, p) {
  var bb = $this;
  var inductionVariable = 0;
  var last = p.d1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, p.f1(n));
    }
     while (inductionVariable < last);
  return bb;
}
function BoundsBuilder__plus_impl_cz7f7x_2($this, rects) {
  var bb = $this;
  var _iterator__ex2g4s = rects.a1();
  while (_iterator__ex2g4s.b1()) {
    var it = _iterator__ex2g4s.c1();
    bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, it);
  }
  return bb;
}
function BoundsBuilder__boundsOrNull_impl_se9lyg($this) {
  return _BoundsBuilder___get_isEmpty__impl__e9t785($this) ? null : _BoundsBuilder___get_bounds__impl__s1l1gx($this);
}
function BoundsBuilder__toString_impl_fmvxh7($this) {
  return 'BoundsBuilder(bounds=' + $this.toString() + ')';
}
function BoundsBuilder__hashCode_impl_649zbo($this) {
  return $this.hashCode();
}
function BoundsBuilder__equals_impl_jngfjs($this, other) {
  if (!(other instanceof BoundsBuilder))
    return false;
  var tmp0_other_with_cast = other instanceof BoundsBuilder ? other.p27_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  if (Companion_instance_5 === VOID)
    new Companion_5();
  return Companion_instance_5;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  if (Companion_instance_6 === VOID)
    new Companion_6();
  return Companion_instance_6;
}
var MatrixType_IDENTITY_instance;
var MatrixType_TRANSLATE_instance;
var MatrixType_SCALE_instance;
var MatrixType_SCALE_TRANSLATE_instance;
var MatrixType_COMPLEX_instance;
var MatrixType_entriesInitialized;
function MatrixType_initEntries() {
  if (MatrixType_entriesInitialized)
    return Unit_instance;
  MatrixType_entriesInitialized = true;
  MatrixType_IDENTITY_instance = new MatrixType('IDENTITY', 0, 1, false, false, false);
  MatrixType_TRANSLATE_instance = new MatrixType('TRANSLATE', 1, 2, false, false, true);
  MatrixType_SCALE_instance = new MatrixType('SCALE', 2, 3, false, true, false);
  MatrixType_SCALE_TRANSLATE_instance = new MatrixType('SCALE_TRANSLATE', 3, 4, false, true, true);
  MatrixType_COMPLEX_instance = new MatrixType('COMPLEX', 4, 5, true, true, true);
}
var Companion_instance_7;
function Companion_getInstance_7() {
  if (Companion_instance_7 === VOID)
    new Companion_7();
  return Companion_instance_7;
}
function MatrixType_IDENTITY_getInstance() {
  MatrixType_initEntries();
  return MatrixType_IDENTITY_instance;
}
function MatrixType_TRANSLATE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_TRANSLATE_instance;
}
function MatrixType_SCALE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_SCALE_instance;
}
function MatrixType_SCALE_TRANSLATE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_SCALE_TRANSLATE_instance;
}
function MatrixType_COMPLEX_getInstance() {
  MatrixType_initEntries();
  return MatrixType_COMPLEX_instance;
}
var Companion_instance_8;
function Companion_getInstance_8() {
  if (Companion_instance_8 === VOID)
    new Companion_8();
  return Companion_instance_8;
}
function ortho(_this__u8e3s4, rect, near, far) {
  near = near === VOID ? 0.0 : near;
  far = far === VOID ? 1.0 : far;
  return Companion_getInstance_8().t2d(rect.t26(), rect.u26(), rect.w26(), rect.v26(), near, far);
}
function scaled(_this__u8e3s4, scale) {
  return _this__u8e3s4.p2a(scale.x2d_1, scale.y2d_1);
}
function get_scale(_this__u8e3s4) {
  return Scale.z2d(_this__u8e3s4.r2b_1, _this__u8e3s4.s2b_1);
}
var Orientation_CLOCK_WISE_instance;
var Orientation_COUNTER_CLOCK_WISE_instance;
var Orientation_COLLINEAR_instance;
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
var Orientation_entriesInitialized;
function Orientation_initEntries() {
  if (Orientation_entriesInitialized)
    return Unit_instance;
  Orientation_entriesInitialized = true;
  Orientation_CLOCK_WISE_instance = new Orientation('CLOCK_WISE', 0, 1);
  Orientation_COUNTER_CLOCK_WISE_instance = new Orientation('COUNTER_CLOCK_WISE', 1, -1);
  Orientation_COLLINEAR_instance = new Orientation('COLLINEAR', 2, 0);
}
var Companion_instance_10;
function Companion_getInstance_10() {
  if (Companion_instance_10 === VOID)
    new Companion_10();
  return Companion_instance_10;
}
var Companion_instance_11;
function Companion_getInstance_11() {
  if (Companion_instance_11 === VOID)
    new Companion_11();
  return Companion_instance_11;
}
function outerCircle(_this__u8e3s4) {
  var centerX = _this__u8e3s4.z2e();
  var centerY = _this__u8e3s4.a2f();
  return new Circle(_this__u8e3s4.b2f(), Companion_getInstance_17().q2f(centerX, centerY, _this__u8e3s4.u26(), _this__u8e3s4.v26()));
}
var Companion_instance_12;
function Companion_getInstance_12() {
  return Companion_instance_12;
}
var Companion_instance_13;
function Companion_getInstance_13() {
  return Companion_instance_13;
}
var Companion_instance_14;
function Companion_getInstance_14() {
  if (Companion_instance_14 === VOID)
    new Companion_14();
  return Companion_instance_14;
}
function toVector2(_this__u8e3s4) {
  return Vector2D.l28(_this__u8e3s4.x2d_1, _this__u8e3s4.y2d_1);
}
function ScaleMode$Companion$COVER$lambda(i, c) {
  return i.v2e(toVector2(c.j2g(i)).k2g());
}
function ScaleMode$Companion$SHOW_ALL$lambda(i, c) {
  return i.v2e(toVector2(c.j2g(i)).l2g());
}
function ScaleMode$Companion$EXACT$lambda(i, c) {
  return c;
}
function ScaleMode$Companion$NO_SCALE$lambda(i, c) {
  return i;
}
var Companion_instance_15;
function Companion_getInstance_15() {
  if (Companion_instance_15 === VOID)
    new Companion_15();
  return Companion_instance_15;
}
var Companion_instance_16;
function Companion_getInstance_16() {
  if (Companion_instance_16 === VOID)
    new Companion_16();
  return Companion_instance_16;
}
function minus(_this__u8e3s4, other) {
  return Vector2D.l28(_this__u8e3s4.c26_1 - other.h27_1, _this__u8e3s4.d26_1 - other.i27_1);
}
function toFloat(_this__u8e3s4) {
  return Size2D.o2e(_this__u8e3s4.b2h_1, _this__u8e3s4.c2h_1);
}
function toInt(_this__u8e3s4) {
  return SizeInt.d2h(numberToInt(_this__u8e3s4.h27_1), numberToInt(_this__u8e3s4.i27_1));
}
function toSize(_this__u8e3s4) {
  return Size2D.s2e(_this__u8e3s4.c26_1, _this__u8e3s4.d26_1);
}
function transformX(_this__u8e3s4, m) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    if (m.r26()) {
      tmp$ret$0 = _this__u8e3s4;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.l28(m.i2a(_this__u8e3s4.c26_1, _this__u8e3s4.d26_1), m.l2a(_this__u8e3s4.c26_1, _this__u8e3s4.d26_1));
  }
  return tmp$ret$0.c26_1;
}
function transformY(_this__u8e3s4, m) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    if (m.r26()) {
      tmp$ret$0 = _this__u8e3s4;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.l28(m.i2a(_this__u8e3s4.c26_1, _this__u8e3s4.d26_1), m.l2a(_this__u8e3s4.c26_1, _this__u8e3s4.d26_1));
  }
  return tmp$ret$0.d26_1;
}
function square($this, x) {
  return x * x;
}
var Companion_instance_17;
function Companion_getInstance_17() {
  if (Companion_instance_17 === VOID)
    new Companion_17();
  return Companion_instance_17;
}
function toInt_0(_this__u8e3s4) {
  return Vector2I.w2f(numberToInt(_this__u8e3s4.c26_1), numberToInt(_this__u8e3s4.d26_1));
}
var Companion_instance_18;
function Companion_getInstance_18() {
  if (Companion_instance_18 === VOID)
    new Companion_18();
  return Companion_instance_18;
}
var Companion_instance_19;
function Companion_getInstance_19() {
  if (Companion_instance_19 === VOID)
    new Companion_19();
  return Companion_instance_19;
}
var Companion_instance_20;
function Companion_getInstance_20() {
  if (Companion_instance_20 === VOID)
    new Companion_20();
  return Companion_instance_20;
}
function interpolate_1(_this__u8e3s4, l, r) {
  return Vector2D.l28(interpolate_0(_this__u8e3s4, l.c26_1, r.c26_1), interpolate_0(_this__u8e3s4, l.d26_1, r.d26_1));
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(Anchor2D, 'Anchor2D');
initMetadataForCompanion(Companion_0);
protoOf(Angle).d1i = isAlmostEquals$default;
initMetadataForClass(Angle, 'Angle', VOID, VOID, [Comparable, IsAlmostEquals]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(BoundsBuilder, 'BoundsBuilder');
initMetadataForCompanion(Companion_2);
initMetadataForClass(Circle, 'Circle');
initMetadataForClass(IPointList$Sublist$listIterator$1);
initMetadataForClass(Sublist, 'Sublist', VOID, VOID, [KtList]);
initMetadataForCompanion(Companion_3);
initMetadataForInterface(IDoubleVectorList, 'IDoubleVectorList', VOID, VOID, [IsAlmostEquals]);
initMetadataForInterface(IPointList, 'IPointList', VOID, VOID, [IDoubleVectorList, KtList]);
initMetadataForCompanion(Companion_4);
initMetadataForClass(Line2D, 'Line2D', Line2D.v28);
initMetadataForCompanion(Companion_5);
initMetadataForClass(MarginInt, 'MarginInt');
initMetadataForCompanion(Companion_6);
protoOf(Matrix).d1i = isAlmostEquals$default;
initMetadataForClass(Matrix, 'Matrix', VOID, VOID, [IsAlmostEquals]);
initMetadataForClass(MatrixType, 'MatrixType');
initMetadataForCompanion(Companion_7);
protoOf(MatrixTransform).d1i = isAlmostEquals$default;
initMetadataForClass(MatrixTransform, 'MatrixTransform', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_8);
initMetadataForClass(Matrix4, 'Matrix4', Matrix4.y2c);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Orientation, 'Orientation');
initMetadataForCompanion(Companion_10);
initMetadataForClass(RectCorners, 'RectCorners');
initMetadataForCompanion(Companion_11);
protoOf(Rectangle).d1i = isAlmostEquals$default;
initMetadataForClass(Rectangle, 'Rectangle', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_12);
initMetadataForClass(RectangleInt, 'RectangleInt', RectangleInt.x2f);
initMetadataForCompanion(Companion_13);
initMetadataForClass(RoundRectangle, 'RoundRectangle');
initMetadataForCompanion(Companion_14);
initMetadataForClass(Scale, 'Scale', Scale.f2g);
initMetadataForCompanion(Companion_15);
initMetadataForClass(ScaleMode, 'ScaleMode');
initMetadataForCompanion(Companion_16);
initMetadataForClass(Size2D, 'Size2D', Size2D.v2g);
initMetadataForClass(SizeInt, 'SizeInt', SizeInt.e2h);
initMetadataForCompanion(Companion_17);
protoOf(Vector2D).d1i = isAlmostEquals$default;
initMetadataForClass(Vector2D, 'Vector2D', Vector2D.w28, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_18);
initMetadataForClass(Vector4F, 'Vector4F');
initMetadataForCompanion(Companion_19);
initMetadataForClass(Vector3F, 'Vector3F');
initMetadataForCompanion(Companion_20);
initMetadataForClass(Vector2I, 'Vector2I', Vector2I.s2i);
//endregion
//region block: init
Companion_instance_2 = new Companion_2();
Companion_instance_3 = new Companion_3();
Companion_instance_9 = new Companion_9();
Companion_instance_12 = new Companion_12();
Companion_instance_13 = new Companion_13();
//endregion
//region block: exports
export {
  MatrixType_IDENTITY_getInstance as MatrixType_IDENTITY_getInstance26n3n49ggvwm4,
  _Angle___init__impl__g23q1m as _Angle___init__impl__g23q1m36yxttgnpy5tv,
  _Angle___get_absoluteValue__impl__4qoakv as _Angle___get_absoluteValue__impl__4qoakv4cdwg294ssle,
  Angle__compareTo_impl_a0hfds as Angle__compareTo_impl_a0hfds24obl4qqhxk1t,
  _Angle___get_cosine__impl__vprvmu as _Angle___get_cosine__impl__vprvmu3ab5uwcliuboq,
  Angle__cosine_impl_bgvzun as Angle__cosine_impl_bgvzun1b2925dagclby,
  _Angle___get_degrees__impl__qg56vw as _Angle___get_degrees__impl__qg56vw2n539uvc01e1n,
  Angle__div_impl_ut2btd as Angle__div_impl_ut2btd1qmy7ftoy1opp,
  Angle__div_impl_ut2btd_0 as Angle__div_impl_ut2btd19ndx9mxcgcss,
  Angle__hashCode_impl_szcndt as Angle__hashCode_impl_szcndtx0rhatnvuhb1,
  Angle__minus_impl_xeau7k as Angle__minus_impl_xeau7ko02ca30grn4a,
  _Angle___get_normalized__impl__9s30ys as _Angle___get_normalized__impl__9s30ys1q15xt9x23bx,
  Angle__plus_impl_26v37k as Angle__plus_impl_26v37karx983dsduoy,
  _Angle___get_radians__impl__n00yt5 as _Angle___get_radians__impl__n00yt518seywpfbf9fr,
  _Angle___get_ratio__impl__ap3on4 as _Angle___get_ratio__impl__ap3on435dv91f5cbp85,
  _Angle___get_sine__impl__15nmyi as _Angle___get_sine__impl__15nmyi39oh4tio4auz1,
  Angle__sine_impl_3l11xv as Angle__sine_impl_3l11xv3pgl8zzgp52i0,
  _Angle___get_tangent__impl__vushdy as _Angle___get_tangent__impl__vushdy2zy6w59e4l7qg,
  Angle__times_impl_v3s9y2_0 as Angle__times_impl_v3s9y21yznxo5bj1uj7,
  Angle__times_impl_v3s9y2 as Angle__times_impl_v3s9y220yjbrxc13c3b,
  Angle__umod_impl_4wilf7 as Angle__umod_impl_4wilf71vq5gai237g1r,
  Angle__unaryMinus_impl_7901fr as Angle__unaryMinus_impl_7901fruk5m76f5kg06,
  Angle__unaryPlus_impl_eyi5pl as Angle__unaryPlus_impl_eyi5plrfyn5fslhvdp,
  _BoundsBuilder___get_bounds__impl__s1l1gx as _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i,
  BoundsBuilder__boundsOrNull_impl_se9lyg as BoundsBuilder__boundsOrNull_impl_se9lyg1z0iqowyff423,
  BoundsBuilder__hashCode_impl_649zbo as BoundsBuilder__hashCode_impl_649zbo2cbmgnd4y2see,
  BoundsBuilder__plus_impl_cz7f7x as BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3,
  BoundsBuilder__plus_impl_cz7f7x_2 as BoundsBuilder__plus_impl_cz7f7xqnc8b6uzo82y,
  BoundsBuilder__plus_impl_cz7f7x_1 as BoundsBuilder__plus_impl_cz7f7xiu6sbkxslhhl,
  BoundsBuilder__plus_impl_cz7f7x_0 as BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm,
  BoundsBuilder__toString_impl_fmvxh7 as BoundsBuilder__toString_impl_fmvxh7qh65bafrb2p,
  _BoundsBuilder___get_xmax__impl__gsz0km as _BoundsBuilder___get_xmax__impl__gsz0km31n4zf6la54qa,
  _BoundsBuilder___get_xmin__impl__o2sib0 as _BoundsBuilder___get_xmin__impl__o2sib0fqg01yornfcx,
  BoundsBuilder__xminOr_impl_k3l1m2 as BoundsBuilder__xminOr_impl_k3l1m233j5xey4uzzri,
  _BoundsBuilder___get_ymax__impl__oia4uz as _BoundsBuilder___get_ymax__impl__oia4uz2kb33iwdnvg1r,
  _BoundsBuilder___get_ymin__impl__5n2e8j as _BoundsBuilder___get_ymin__impl__5n2e8j1x2fwruhjr6r5,
  Companion_getInstance as Companion_getInstanceeqp3ibr2vvu9,
  Companion_getInstance_0 as Companion_getInstance3rze5babd97ff,
  Companion_getInstance_1 as Companion_getInstance2yu48324co92b,
  Companion_getInstance_5 as Companion_getInstancenbeyvbsm21qs,
  Companion_getInstance_6 as Companion_getInstance1zxby1ngivg0d,
  Companion_getInstance_8 as Companion_getInstance3qti4zygy7usz,
  Companion_getInstance_10 as Companion_getInstance3lu3946d91kk8,
  Companion_getInstance_11 as Companion_getInstance1bdwtq6rroayu,
  Companion_instance_12 as Companion_instanceu31qrc8c1r0r,
  Companion_getInstance_15 as Companion_getInstance23o88a0u6ly94,
  Companion_getInstance_16 as Companion_getInstance1j5nd3fbu9uao,
  Companion_getInstance_17 as Companion_getInstancewdpvtc2ehxkt,
  Companion_getInstance_19 as Companion_getInstance1yq7a1f60lp2k,
  Anchor2D as Anchor2D3ucppq7m9n3z8,
  Angle_between as Angle_between72970e1vlen9,
  Angle as Angle2itorpob18n08,
  BoundsBuilder as BoundsBuilder162uwsje56mvu,
  Circle as Circle1sk1qi5ph1m23,
  isAlmostEquals_0 as isAlmostEquals2qd88bwpjj4z5,
  isNotEmpty as isNotEmptyrwyeygz7izwg,
  IDoubleVectorList as IDoubleVectorListoa05cse3he2p,
  containsAll as containsAll194lepx84fvib,
  iterator as iterator1sm8hwbj0nmg8,
  listIterator as listIteratorrk3szyua4uzm,
  listIterator_0 as listIterator3ooh2yjav3kr9,
  subList as subList2funs4qwcrhhq,
  IPointList as IPointListz7raskb2mrxa,
  Line2D as Line2D2pf35pcx71ncp,
  MarginInt as MarginInt3jiec8xsxkfd,
  Matrix4 as Matrix43neeu8v4zk4i7,
  MatrixTransform as MatrixTransform1wlsrhxt7473v,
  Matrix as Matrix1p940sdz227jj,
  RectCorners as RectCorners2yrtl8r42p5bs,
  RectangleInt as RectangleInt3lmu13ytuf5lk,
  Rectangle as Rectangle3q03woyn9k8x1,
  RoundRectangle as RoundRectangle271svjyf7w51p,
  Scale as Scale2cm697xlulcp5,
  Size2D as Size2Dum5ayuyhhau7,
  SizeInt as SizeInte6w85oa6mz6v,
  Vector2D as Vector2D378fe5rov8fgw,
  Vector2I as Vector2I2k5512l4eeahb,
  Vector4F as Vector4F1clr35ctch8js,
  adjustFromUp as adjustFromUp1ak85cceintt4,
  get_degrees as get_degrees3czcd4ojw4i,
  get_degrees_0 as get_degrees1wvulgxbo1fy6,
  interpolateAngleDenormalized as interpolateAngleDenormalized1hkwzk523mo1c,
  minus as minus35u9jfp5de3x,
  ortho as orthow9c0o91bw54n,
  outerCircle as outerCircle30hn5vvbpz9gu,
  get_radians as get_radians391vbqqjsolq6,
  get_radians_0 as get_radians87y5j8tewvub,
  get_scale as get_scale17gmsnxnqj6j9,
  scaled as scaled2eehd42i2trq9,
  toFloat as toFloat3b315y36g90cd,
  toInt as toIntp2twe4onfbic,
  toInt_0 as toIntu0rc68akxu7a,
  transformX as transformX33nszy4vzqsfy,
  transformY as transformY3ktoxhxwkzwk1,
  interpolate_1 as interpolatewhd2sgxffql5,
};
//endregion
